import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Broker } from '@c4/core';
import { Observable } from 'rxjs/Observable';

export interface versions {
  versions?: string;
}

export const VERSIONS_GET: string = 'SYSMAN_VERSIONS_GET';

export const versionsReducer = (state: versions, {type, payload}): versions => {
  switch (type) {

    case VERSIONS_GET:
      //console.log("in versionsReducer: " + type, "state=", state, "payload=", payload);
      let newState = Object.assign({}, state, { versions: payload });
      return newState;

    default:
      return state;
  }
}

@Injectable()
export class VersionsService {

  constructor(private broker: Broker, protected store: Store<any>) {}

  public getAllVersions = (ip? : string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (msg: string) => any) => {

    let request: any = {
        method: 'GET',
        path: '/api/v1/sysman/package_versions'+ (ip ? "?ip="+ip : "")
    };
    this.broker.call(request).then(
          (response: any) => {
              this.store.dispatch({
                 type: VERSIONS_GET,
                 payload: { versions: response}
              });
              resolve(response);
          },
          (error:any) => {
              reject(error);
          });
    });
  }

  // get a version for a library
  public getVersion(library : string, allVersions : any) : string {

    if (!allVersions)
        return "";

    // match library names with entries in sysman package list
    switch (library) {
        case "c4lookup": 
            library = "c4lookupserver";
            break;
        case "driverwizd": 
            library = "driverwiz-server";
            break;
        case "net-watchdog": 
            library = "watchdogd";
            break;
        case "rhapServer": 
            library = "rhapserver";
            break;
        case "snmpd": 
            library = "netsnmp";
            break;
        case "upmand": 
            library = "upman-server";
            break;
    }

    let version = allVersions[library];
    if (!version)
        return "";
    else
        return version;
  }

  // get version info for a set of libraries - return in same order array as sent in libraries
  public getVersions (libraries : Array<string>, allVersions : any) : Array<string> {

    var versions : Array<string> = [];
    if (!allVersions)
        return versions;

    libraries.forEach(lib => {
        let version = this.getVersion(lib, allVersions);
        versions.push(version);
    });
    return versions;
  }

  // get updateable OS versions 
  public getUpateVersions = (): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (msg: string) => any) => {
        this.broker.call({ method: 'GET',path: '/api/v1/agents/update_manager/versions_available'}).then(
              (response: any) => {
                  resolve(response);
              },
              (error: any) => {
                  reject(error);
              });
      });
  }

  public compareVersions (a, b) : number {
      var i, diff;
      var regExStrip0 = /(\.0+)+$/;
      var segmentsA = a.replace(regExStrip0, '').split('.');
      var segmentsB = b.replace(regExStrip0, '').split('.');
      var l = Math.min(segmentsA.length, segmentsB.length);

      for (i = 0; i < l; i++) {
          diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10);
          if (diff) {
              return diff;
          }
      }
      return segmentsA.length - segmentsB.length;
  }
  
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/services/versions.service.ts